import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { openModal, closeModal } from 'shared/store/modal'
import { getModalState } from 'shared/store/modal/selectors'

interface IProps {
  closeOnDismountIfType?: string
}

interface IOpenProps {
  type?: string
  data?: any
  overrideType?: boolean
}

const useModal = (options?: IProps) => {
  const dispatch = useDispatch()
  const { open: isOpen, type, data: modalData } = useSelector(getModalState)

  const open = (props?: IOpenProps) => {
    if (!props?.type) {
      dispatch(openModal())
      return
    }

    dispatch(
      openModal({
        type: props.type,
        data: props.data,
        overrideType: props.overrideType,
      })
    )
  }

  const isModalType = (isOpenedType: string) => isOpenedType === type

  const close = () => dispatch(closeModal())

  // To handle dismounting if we are navigating out from anywhere with the back button.
  useEffect(() => {
    return () => {
      if (
        options?.closeOnDismountIfType &&
        options.closeOnDismountIfType === type
      )
        close()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, options?.closeOnDismountIfType])

  return { open, close, isModalType, isOpen, type, modalData }
}

export default useModal
